/* CUVVO hardening: legacy Elixer cart/free-gift automation intentionally disabled.
   The CUVVO funnel owns checkout through strapless-bundle-checkout-v2.
   Keeping this asset inert prevents duplicate cart polling, hidden gift triggers,
   shipping-protection AJAX and broad /cart/add interception from attaching. */
(() => {
  'use strict';
  window.__cuvvoLegacyCustomDisabled = true;
})();
